"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLegendTitle = exports.StyledCell = exports.StyledRow = exports.StyledTable = exports.StyledSpan = exports.StyledCrossText = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledCrossText = styled_components_1.default.div `
  font-size: 12px;
  text-decoration: line-through;
`;
exports.StyledSpan = styled_components_1.default.span `
  display: flex;
`;
exports.StyledTable = styled_components_1.default.table `
  border-collapse: collapse;
  width: 200px;
`;
exports.StyledRow = styled_components_1.default.tr `
  height: 30px;
`;
exports.StyledCell = styled_components_1.default.td `
  padding: 5px;
  border: none;
  text-align: left; 

  &:first-child {
    width: 25%;
  }
`;
exports.StyledLegendTitle = styled_components_1.default.div `
  display: flex;
  height: 25px;
  align-items: center;
`;
